import React from "react";
import { Button, Skeleton, useWizard } from "@picklebet/ui";
import { useCreditCards } from "hooks/firestore/user/useCreditCards";
import { useDepositWizard } from "features/wallet/components/deposit/hooks/useDepositWizard";
import type { DepositMethodStepName } from "@/features/wallet/components/deposit/utils/registry";
import type { PickerActionProps } from "@/features/wallet/components/deposit/types";

export const DebitCardPicker = ({
  variant = "secondary",
}: PickerActionProps) => {
  const { goTo } = useWizard<DepositMethodStepName>();
  const { setSelectedMethodId, submitting } = useDepositWizard();
  const { creditCards, isLoading } = useCreditCards();

  if (isLoading) {
    return <Skeleton size="sm" />;
  }

  const openCardStep = (
    event: React.MouseEvent,
    step: DepositMethodStepName,
  ) => {
    event.preventDefault();

    // ensure the debit card method is selected when a card is added or changed
    setSelectedMethodId("debit-card");

    goTo(step);
  };

  if (creditCards.length === 0) {
    return (
      <Button
        size="sm"
        disabled={submitting}
        onClick={(e) => openCardStep(e, "debit-card/add")}
      >
        Add Card
      </Button>
    );
  }

  return (
    <Button
      size="sm"
      variant={variant}
      disabled={submitting}
      onClick={(e) => openCardStep(e, "debit-card/select")}
    >
      Change
    </Button>
  );
};
